import { number, object, string } from 'yup';

export default object({
    operation_type_id: number(),
    operation_type_config_id: number(),
    operation_date: string().nullable(),
});
